var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9287 16.9385H11.2869C8.16855 16.9385 5.64062 19.4664 5.64062 22.5848V45.1699C5.64062 48.2882 8.16855 50.8161 11.2869 50.8161H48.9287C52.0471 50.8161 54.575 48.2882 54.575 45.1699V22.5848C54.575 19.4664 52.0471 16.9385 48.9287 16.9385Z",
    stroke: "#65C953",
    strokeWidth: 4.32026,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3829 16.9379V13.4089C48.3827 12.5434 48.1914 11.6886 47.8227 10.9056C47.454 10.1225 46.9171 9.43043 46.2501 8.87877C45.5832 8.32712 44.8027 7.92946 43.9644 7.71416C43.1261 7.49887 42.2506 7.47125 41.4004 7.63327L10.4211 12.9208C9.07582 13.1771 7.86215 13.895 6.98944 14.9504C6.11673 16.0059 5.6397 17.3328 5.64063 18.7023V24.4662",
    stroke: "#65C953",
    strokeWidth: 4.32026,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2876 37.6417C42.5431 37.6417 41.8154 37.4209 41.1964 37.0073C40.5773 36.5937 40.0949 36.0058 39.81 35.318C39.5251 34.6301 39.4505 33.8733 39.5958 33.1431C39.741 32.4129 40.0995 31.7422 40.6259 31.2158C41.1524 30.6894 41.8231 30.3309 42.5533 30.1856C43.2834 30.0404 44.0403 30.1149 44.7281 30.3998C45.4159 30.6847 46.0038 31.1672 46.4174 31.7862C46.831 32.4052 47.0518 33.133 47.0518 33.8775C47.0518 34.8758 46.6552 35.8332 45.9493 36.5391C45.2434 37.2451 44.2859 37.6417 43.2876 37.6417Z",
    fill: "#65C953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletOutline);
export default __webpack_public_path__ + "static/media/wallet-outline.7bdf0a384492dd7c29d68392daf3484f.svg";
export { ForwardRef as ReactComponent };